<template>
    <SlideIntroLayout class="override" :videoUrl="require('@/assets/vids/intro-3.mp4')" :slideIndex="2" :durationMs="11000" nextPageId="AlphaGoat01S4">
        <template #description>
            All Your Attestations, Seamlessly Unified
        </template>
    </SlideIntroLayout>
</template>
